import * as types from "../types/domiclio";

const initialState = {
  domicilioError: null,
  departamentoLoading: false,
  provinciaLoading: false,
  distritoLoading: false,
  departamentos: [],
  provincias: [],
  distritos: [],
  selectedDepartamento: {},
  selectedProvincia: {},
  selectedDistrito: {},
	nombreVia: '',
  tipoVia: '',
  numeroVia: '',
  validUbigeo: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.DEPARTAMENTOS:
      return {
        ...state,
        departamentos: action.payload,
        departamentoLoading: false,
        domicilioError: null,
      };
    case types.PROVINCIAS:
      return {
        ...state,
        provincias: action.payload,
        provinciaLoading: false,
        distritoLoading: false,
        domicilioError: null,
      };
    case types.DISTRITOS:
      return {
        ...state,
        distritos: action.payload,
        distritoLoading: false,
        domicilioError: null,
      };
    case types.LOADING_DEPARTAMENTO:
      return {
        ...state,
        departamentos: [],
        departamentoLoading: true,
        domicilioError: null,
      };
    case types.LOADING_PROVINCIA:
      return {
        ...state,
        provincias: [],
        provinciaLoading: true,
        distritoLoading: false,
        domicilioError: null,
      };
    case types.LOADING_DISTRITO:
      return {
        ...state,
        distritos: [],
        distritoLoading: true,
        domicilioError: null,
      };
    case types.DOMICILIO_ERROR_API:
      return {
        ...state,
        distritoLoading: true,
        provinciaLoading: true,
        departamentoLoading: true,
        domicilioError: action.error,
      };

	  case types.SELECT_DOMICILIO:
	  	return {
			  ...state,
			  selectedDepartamento: action.payload.departamento,
			  selectedProvincia: action.payload.provincia,
			  selectedDistrito: action.payload.distrito,
			  nombreVia: action.payload.nombreVia,
			  tipoVia: action.payload.tipoVia,
			  numeroVia: action.payload.numeroVia,
        validUbigeo: action.payload.validUbigeo,
		  };

	  case types.CLEAN_DOMICILIO:
	  	return initialState

    case types.CLEAN_UBIGEO:
      return {
        ...state,
        selectedDepartamento: {},
        selectedProvincia: {},
        selectedDistrito: {},
        nombreVia: '',
        tipoVia: '',
        numeroVia: '',
      };

    default:
      return state;
  }
};
